import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

let smoother

export const smoothScroller = () => {

	smoother = ScrollSmoother.create({
		wrapper: '[data-load="container"]',
		content: 'main',
		smooth: 1,
		effects: true,
		smoothTouch: 0.1,
		onUpdate: self => scrollDirection(self),
	})

	detectScroll()
	deviceFixes()
	scrollTo()

}

const detectScroll = () => {

	window.addEventListener('scroll', () => {
		if (window.pageYOffset > 5) {
			document.body.setAttribute('data-scroll-detected', true)
		} else {
			document.body.removeAttribute('data-scroll-detected')
		}
	})

}

const scrollTo = () => {

	let links = document.querySelectorAll('[data-scroll-to]')

	if (!links) return false

	links.forEach(link => {
		link.addEventListener('click', (e) => {
			let target = link.getAttribute('data-scroll-to')
			smoother.scrollTo(target, true, 'top 100px')
			e.preventDefault()
		})
	})

}

export const scrollToEl = id => {
	smoother.scrollTo(id, true, 'top 100px')
}

export const snapToTop = () => {
	if (smoother) {
		smoother.scrollTop(0)
	} else {
		window.scroll(0, 0)
	}
}

const scrollDirection = self => {
	let direction = self.getVelocity() < 0 ? 'backwards' : 'forwards';
	document.body.setAttribute('data-scroll-direction', direction)
}

const deviceFixes = () => {

	/*
	Prevent scrolltrigger positioning from being recalculated on touch devices
	This prevents animations "jumping" when a browser toolbar appears or disappears
	*/

	if (window.ontouchstart !== undefined) {
		ScrollTrigger.config({
			autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load',
		})
	}

}

export default () => { }